import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { KpiTargetRecord, SetKpiTargetInput } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

export interface SetKpiTargetVars {
  readonly kpiId: string;
  readonly input: SetKpiTargetInput;
}

/**
 * Set / revise the KPI-owned Target (`POST /v1/kpis/:id/targets`). Invalidates
 * the KPI's detail and every Hoshin X-Matrix projection of a linked TTI. The
 * list row does not show the target, so KPI lists are left alone.
 */
export function useSetKpiTarget() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<KpiTargetRecord, Error, SetKpiTargetVars>({
    mutationFn: ({ kpiId, input }) => kpiApi.setTarget(config, kpiId, input),
    onSuccess: (_data, { kpiId }) => {
      void qc.invalidateQueries({ queryKey: kpiKeys.detail(kpiId) });
      void qc.invalidateQueries({ queryKey: ["hoshin", "x-matrix"] });
    },
  });
}
